<script>
    import { params, afterPageLoad, metatags } from '@sveltech/routify'
    import { onMount } from 'svelte'
    import { apiURL } from '../store.js'
    import Loading from '../components/icons/Loading.svelte'
    import Header from '../components/Header.svelte'
    import MainContent from '../components/MainContent.svelte'
    import DiagramsContent from '../components/pages/DiagramsContent.svelte'
    import UpdatesContent from '../components/pages/UpdatesContent.svelte'
    import LabAtWorkContent from '../components/pages/LabAtWorkContent.svelte'

    metatags.description = "We're programming new behaviors in living cells with synthetic and natural biological circuits"

    let windowWidth

    let slug = ''
    $: if ($params.slug) { slug = $params.slug } else { slug = 'homePage' }

    const pages = getPages()
    const header = getHeader()

    const pageModels = [
        'one off page',
        'home.PublicationListingsPage',
        'home.TeachingPage',
        'home.NewsListingPage',
        'home.PersonListingPage',
        'home.BasicPage',
        'home.ResourcesPage'
    ]

    const oneOffPages = [
        {
            title: 'Updates',
            meta: {
                type: 'one off page'
            }
        },
        {
            title: 'Lab Life',
            meta: {
                type: 'one off page'
            }
        },
        {
            title: 'Diagrams',
            meta: {
                type: 'one off page'
            }
        }
    ]

    async function getPages () {
        const pageMetas = await fetch(`${apiURL}/api/v2/pages/`)
        const pageMetasJSON = await pageMetas.json()
        let pages = await Promise.all(
            pageMetasJSON.items.map(async pageMeta =>
                await fetch(pageMeta.meta.detail_url).then(res => res.json())
            )
        )
        pages = pages.filter(page => pageModels.includes(page.meta.type))
        pages = reorderPages(pages)
        pages = [...pages, ...oneOffPages]
        return pages
    }

    function reorderPages (pages) {
        const researchIndex = pages.findIndex(element => element.title == 'Research')
        pages.move(researchIndex, 0)
        const pubsIndex = pages.findIndex(element => element.title == 'Publications')
        pages.move(pubsIndex, 1)
        const peopleIndex = pages.findIndex(element => element.title == 'People')
        pages.move(peopleIndex, 2)
        const resourceIndex = pages.findIndex(element => element.title == 'Resources')
        pages.move(resourceIndex, 3)
        const teachingIndex = pages.findIndex(element => element.title == 'Teaching')
        pages.move(teachingIndex, 4)
        return pages
    }

    Array.prototype.move = function (from, to) {
        this.splice(to, 0, this.splice(from, 1)[0])
    }

    function getHeader () {
        return fetch(`${apiURL}/api/v2/snippets/`)
            .then(res => res.json())
            .then(obj => obj.items[0])
    }

    function getDescription () {
        return fetch(`${apiURL}/api/v2/snip`)
    }
</script>

<svelte:window bind:innerWidth={windowWidth} />
{#await pages}
    <Loading />
{:then pages}
    {#await header then header}
        <Header {header} {pages} {slug} />
    {/await}

    <div id="root">
        {#if slug === 'homePage' || pages
            .filter(page => page.meta.type != 'one off page')
            .some(page => page.title.toLowerCase() === slug)
        }
            <MainContent {pages} {slug} {windowWidth} />
        {:else}
            {#if slug == 'diagrams'}
                <DiagramsContent />
            {:else if slug == 'updates'}
                <UpdatesContent />
            {:else if slug == 'lablife'}
                <LabAtWorkContent />
            {/if}
        {/if}
    </div>
{/await}

<style lang="scss">
    @import "../styles/vars";

    #root {
        position: relative;
        top: 120px;
        left: 0;
        width: 100vw;
        bottom: 0;
        overflow: hidden;
        min-height: calc(100vh - 120px);
    }

    @include respond-to(phone) {
        #root {
            width: 100%;
            top: 80px;
        }
    }
</style>
